import { createGeneralSelectors } from '../_common/selectors';
import { createSelector } from 'reselect';

const getCpsrChapterSlice = state => state.cpsrChapters;
export const { getById, getIds, makeGetItemById: createGetProductById } = createGeneralSelectors(
  getCpsrChapterSlice,
);

export const getCpsrChapterList = createSelector([getIds, getById], (allIds, byId) => allIds.map(id => byId[id]));
